import { Chip, Tooltip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

/**
 * Visual marker for `stability: 'mature'` flags. Rendered next to the flag
 * label in both the global App Config panel and the per-therapist override
 * panel to make it obvious the flag is shipped/stable and should not be
 * casually flipped off.
 */
export const MatureChip = () => (
  <Tooltip title="Mature: this flag is shipped and stable. The global control is read-only in admin to prevent accidental disabling.">
    <Chip
      size="small"
      variant="outlined"
      color="default"
      icon={
        <LockIcon
          sx={{
            fontSize: '0.85rem !important',
            marginLeft: '6px',
          }}
        />
      }
      label="Mature"
      sx={{ height: 22 }}
    />
  </Tooltip>
);
